module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Value),
      expression: "Value"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.Value)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keydown": _vm.onKeyDown,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.Value = $event.target.value
      }, _vm.onInput]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fix"
  }, [_vm._v(_vm._s(_vm.fixed))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-843031fa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/domain.vue
// module id = 349
// module chunks = 0